import Employees from '@/views/employees/employees.vue'
import NewEmployee from '@/views/employees/new-employee.vue'
import EditEmployee from '@/views/employees/edit-employee.vue'
import SingleEmployee from '@/views/employees/single-employee.vue'
import { EmployeeRouteNames } from '@/router/routes-names'

export const employeesRoutes = [
    {
        path: '/employees',
        name: EmployeeRouteNames.LIST,
        component: Employees,
        props: true
    },
    {
        path: '/employees/new',
        name: EmployeeRouteNames.NEW,
        component: NewEmployee
    },
    {
        path: '/employees/edit/:id',
        name: EmployeeRouteNames.EDIT,
        component: EditEmployee
    },
    {
        path: '/employees/single/:id',
        name: EmployeeRouteNames.SINGLE,
        component: SingleEmployee
    }
]
